import { render, staticRenderFns } from "./print-way.vue?vue&type=template&id=f12bc4a6&scoped=true&"
import script from "./print-way.vue?vue&type=script&lang=js&"
export * from "./print-way.vue?vue&type=script&lang=js&"
import style0 from "./print-way.vue?vue&type=style&index=0&id=f12bc4a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12bc4a6",
  null
  
)

export default component.exports